import { useEffect, useState } from "react";
import { ArrowDownNarrowWide, ArrowDownRight, ArrowRight, ArrowUpRight, ArrowUpWideNarrow } from "lucide-react";
import { Popup } from "@/components/common/Popup";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { SpotPreview } from "@/components/spot/SpotPreview";
import { useApiFetch } from "@/helper/apiFetch";
import { sortData, type SortCategory } from "@/helper/sort";
import { useTranslate } from "@/helper/translate";
import { useNavigate } from "react-router-dom";

type DashboardSpotItem = {
  tom: string;
  id: string;
  customerName: string;
  name: string;
};



export function DashboardPage() {
  const { translate } = useTranslate();
  const apiFetch = useApiFetch();
  const navigate = useNavigate();
  const currentDate = new Intl.DateTimeFormat("de-DE", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date());
  const [selectedSpotId, setSelectedSpotId] = useState<string | null>(null);
  const [spots, setSpots] = useState<DashboardSpotItem[]>([]);
  const [sortCategory, setSortCategory] = useState<SortCategory>({ name: "changeDate", direction: true });
  const [isLoadingSiteOccupancies, setIsLoadingSiteOccupancies] = useState(true);
const [numbers, setNumbers] = useState<{ name: string; siteId: string; loopLength: number; orderLength: number; bookedLength: number }[]>([{ name: "", siteId: "", loopLength: 0, orderLength: 0, bookedLength: 0 }]);
  const openOccupancyForSite = (siteId: string) => {
    const params = new URLSearchParams({ siteId });
    navigate(`/occupancy?${params.toString()}`);
  };

  const handleSortCategoryChange = (newCategory: string | number) => {
    const nextSort: SortCategory = {
      name: newCategory,
      direction: sortCategory?.name === newCategory ? !sortCategory.direction : true,
    };

    setSortCategory(nextSort);
    setSpots(sortData(spots, nextSort));
  };

      useEffect(() => {
  
      apiFetch(`/App/GetSpotsToApprove`)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch spots");
          return res.json();
        })
        .then((data) => {
          setSpots(data);
         
        })
        .catch((err) => {
          console.error(err);
        });
  

          apiFetch(`/App/GetOccupancySummary`)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch spots");
          return res.json();
        })
        .then((data) => {
          setNumbers(data);
         setIsLoadingSiteOccupancies(false);
        })
        .catch((err) => {
          console.error(err);
        });
  
  
  
    }, [apiFetch]);


  return (
    <div className="h-[calc(100vh-60px)] flex flex-col">

      <div className="content-header flex justify-between pt-[0.6rem] pb-[0.6rem] px-8 bg-gray-100 dark:bg-zinc-900">
        <h1 className="font-bold text-2xl">{translate("ui.dashboard")}</h1>
      </div>

      {/*
      <div className="p-8 space-y-8">
      <BusLegend />
      <BusChartItem />
      */}

      <div className="flex-1 overflow-auto px-10">
        <section className="py-1">
          <h2 className="mt-10 mb-4 pl-4 text-2xl">{translate("ui.spots")} zur Freigabe</h2>
          <div className="overflow-x-auto my-0 border rounded-xl shadow-xl border-gray-100 dark:border-zinc-600">
            <table className="table-auto w-full border-collapse">
              <thead className="border-b border-gray-300 text-sm text-gray-600 dark:text-gray-50 dark:border-zinc-900">
                <tr>
                  <th className="px-4 py-2 text-left cursor-pointer bg-gray-200 dark:bg-zinc-900" onClick={() => handleSortCategoryChange("changeDate")}>
                    <div className="flex items-center gap-1">
                      {translate("ui.changeDate")}
                      {sortCategory?.name === "changeDate" ? (
                        sortCategory.direction ? <ArrowDownNarrowWide className="w-3 h-3" /> : <ArrowUpWideNarrow className="w-3 h-3" />
                      ) : <div className="w-3" />}
                    </div>
                  </th>
                  <th className="px-4 py-2 text-left cursor-pointer bg-gray-200 dark:bg-zinc-900" onClick={() => handleSortCategoryChange("customerName")}>
                    <div className="flex items-center gap-1">
                      {translate("ui.customer")}
                      {sortCategory?.name === "customerName" ? (
                        sortCategory.direction ? <ArrowDownNarrowWide className="w-3 h-3" /> : <ArrowUpWideNarrow className="w-3 h-3" />
                      ) : <div className="w-3" />}
                    </div>
                  </th>
                  <th className="px-4 py-2 text-left cursor-pointer bg-gray-200 dark:bg-zinc-900" onClick={() => handleSortCategoryChange("name")}>
                    <div className="flex items-center gap-1">
                      {translate("ui.spot")}
                      {sortCategory?.name === "name" ? (
                        sortCategory.direction ? <ArrowDownNarrowWide className="w-3 h-3" /> : <ArrowUpWideNarrow className="w-3 h-3" />
                      ) : <div className="w-3" />}
                    </div>
                  </th>
                 
                </tr>
              </thead>
              <tbody>
                {spots.map((spot, index) => (
                  <tr onClick={() => setSelectedSpotId(spot.id)} key={`${spot.name}-${index}`} className="cursor-pointer border-t hover:bg-gray-100 dark:bg-zinc-700 dark:hover:bg-zinc-600">
                    <td className="px-4 py-2">{new Date(spot.tom).toLocaleDateString()}</td>
                    <td className="px-4 py-2">{spot.customerName}</td>
                    <td className="px-4 py-2">{spot.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="my-10 overflow-x-auto my-0 rounded-xl shadow-xl bg-white dark:bg-zinc-700 min-h-[200px] p-4">
            <span className="text-2xl pr-4">Auslastung</span> {currentDate}

            {/* <TooltipProvider>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 mt-4">
                {isLoadingSiteOccupancies ? (
                  <div className="col-span-full text-center text-gray-500">{translate("common.loading")}</div>
                ) : siteOccupancies.map((site) => (
                  <div
                    key={site.id}
                    className="auslastungToday overflow-x-auto my-0 rounded-xl bg-gray-100 hover:bg-gray-200 dark:bg-zinc-600 dark:hover:bg-zinc-800 min-h-[100px] px-3 py-2 cursor-pointer"
                    onClick={() => openOccupancyForSite(site.id)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        openOccupancyForSite(site.id);
                      }
                    }}
                    role="link"
                    tabIndex={0}
                  >
                    <div className="flex justify-between items-start gap-2">
                      <div className="auslastungSiteName font-semibold text-left">{site.name}</div>
               
                    </div>

                    <table className="mt-2 table-auto w-full border-collapse">
                      <tbody>
                        <tr>
                          <td className="auslastungOrder">Aufträge</td>
                          <td className="auslastungOrderPercent text-right">{site.orderPercent} %</td>
                        </tr>
                        <tr>
                          <td className="auslastungBooking">Buchungen</td>
                          <td className="auslastungBookingPercent text-right">{site.bookingPercent} %</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            </TooltipProvider> */}


 <TooltipProvider>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 mt-4">
                {isLoadingSiteOccupancies ? (
                  <div className="col-span-full text-center text-gray-500">{translate("common.loading")}</div>
                ) : numbers.map((site) => (
                  <div
                    key={site.siteId}
                    className="auslastungToday overflow-x-auto my-0 rounded-xl bg-gray-100 hover:bg-gray-200 dark:bg-zinc-600 dark:hover:bg-zinc-800 min-h-[100px] px-3 py-2 cursor-pointer"
                    onClick={() => openOccupancyForSite(site.siteId)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        openOccupancyForSite(site.siteId);
                      }
                    }}
                    role="link"
                    tabIndex={0}
                  >
                    <div className="flex justify-between items-start gap-2">
                      <div className="auslastungSiteName font-semibold text-left">{site.name}</div>
               
                    </div>

                    <table className="mt-2 table-auto w-full border-collapse">
                      <tbody>
                        <tr>
                          <td>
                             <div className="w-100 relative">
                                <div className="relative z-10 pl-1 flex justify-between">
                                <div>Aufträge</div> <div > {Math.round(site.orderLength/site.loopLength * 100)} %</div>
                                </div>
                                 <div className="bg-[rgba(3,105,160,0.5)] dark:bg-[rgba(3,105,160,0.5)] rounded-sm absolute top-0 left-0"

                                  style={{ width: `${(site.orderLength / site.loopLength) * 100}%`, height: "100%" }}

                                >

                                </div>
                                </div>
                          </td>
                          {/* <td className="auslastungOrder">Aufträge</td>
                          <td className="auslastungOrderPercent text-right">{Math.round(site.orderLength/site.loopLength * 100)} %</td> */}
                        </tr>
                        <tr>
                          {/* <td className="auslastungBooking">Buchungen</td> */}
                          <div className="w-100 relative">
                                <div className="relative z-10 pl-1 flex justify-between">
                                <div>Buchungen</div> <div > {Math.round(site.bookedLength/site.loopLength * 100)} %</div>
                                </div>
                                <div className="bg-[rgba(3,105,160,0.5)] dark:bg-[rgba(3,105,160,0.5)] rounded-sm absolute top-0 left-0"

                                  style={{ width: `${(site.bookedLength / site.loopLength) * 100}%`, height: "100%" }}

                                >

                                </div>
                                </div>

                          {/* <td className="auslastungBookingPercent text-right">{Math.round(site.bookedLength/site.loopLength * 100)} %</td> */}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            </TooltipProvider>

          </div>
        </section>
      </div>

      <Popup
        isOpen={selectedSpotId != null}
        onClose={() => setSelectedSpotId(null)}
        title={translate("common.preview")}
       
      >
        {selectedSpotId && (
          <SpotPreview
            spotId={selectedSpotId}
            statusId={2}
            onStatusChanged={(statusId: number, comment: string | null) => { if(statusId > 2) setSpots(prev => prev.filter(spot => spot.id != selectedSpotId)); setSelectedSpotId(null); }}
          />
        )}
      </Popup>
    </div>
  );
}